export const getContentFromAllFiles = ({ allFile: { edges } }, name) => {
  const [page] = edges.filter(({ node }) => node.name === name);
  const { childMarkdownRemark: { frontmatter, html } } = page.node;
  return {
    ...frontmatter,
    html
  }
}